var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ShortlistContext',[(_vm.user.isInvestorOrOrganizer)?_c('ShortlistStartup',{attrs:{"startup":_vm.startup,"org-id":_vm.user.organizationId}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }